import api from '@/lib/api/axios'
import type { ForensicsEnvironment, ForensicsObjectVersion } from '@/types/entities'

export const forensicsApi = {
    listEnvironments: (params?: { vaultId?: number }) =>
        api.get<ForensicsEnvironment[]>('/api/forensics/environments', { params }),

    getEnvironment: (id: number) =>
        api.get<ForensicsEnvironment>(`/api/forensics/environments/${id}`),

    createEnvironment: (data: {
        name: string
        vaultId: number
        securityGroupId: string
        awsAccountId: string
        description?: string
        servers?: Array<{ computeObjectId: string; computeObjectVersionId?: number }>
    }) => api.post<ForensicsEnvironment>('/api/forensics/environments', data),

    updateEnvironment: (id: number, data: {
        name?: string
        securityGroupId?: string
        awsAccountId?: string
        description?: string
        status?: string
        servers?: Array<{ computeObjectId: string; computeObjectVersionId?: number }>
    }) => api.put<ForensicsEnvironment>(`/api/forensics/environments/${id}`, data),

    deleteEnvironment: (id: number) =>
        api.delete(`/api/forensics/environments/${id}`),

    listVersions: (envId: number) =>
        api.get<ForensicsObjectVersion[]>(`/api/forensics/environments/${envId}/versions`),

    startVersion: (envId: number, data: { objectId: string; objectVersionId: number }) =>
        api.post<ForensicsObjectVersion>(`/api/forensics/environments/${envId}/versions`, data),

    stopVersion: (envId: number, versionId: number) =>
        api.delete(`/api/forensics/environments/${envId}/versions/${versionId}`),

    listComputeObjects: () =>
        api.get<Array<{ ObjectID: string; ObjectDescription: string; LayerID: number }>>('/api/forensics/compute-objects'),
}
